<template>
  <div class="paypalInfo">
    <div class="page_cont">
      <div class="page_title">PayPal购买</div>
      <el-steps :active="active" finish-status="success" simple>
        <el-step title="步骤一：选择购买数量" />
        <el-step title="步骤二：Paypal支付" />
        <el-step title="步骤三：支付结果" />
      </el-steps>
      <!-- <el-button style="margin-top: 12px" @click="next">Next step</el-button> -->
      <div class="step_cont">
        <paypal-step1 @setBuyData="setBuyData" :active="active" v-if="active == 0"></paypal-step1>
        <paypal-step2 :amount="pay_usdt" :buy_number="buy_data.number" :wallet="buy_data.wallet" currency="USD" :on-approve="handleApprove" :on-error="handleError" v-if="active == 1"></paypal-step2>
        <paypal-step3 @setStep="setStep" :id="paypal_order_id" :wallet="buy_data.wallet" :buy_number="buy_data.number" :usdt="buy_data.usdt" v-if="active == 2 || active == 3"></paypal-step3>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, ref, computed, inject, onMounted } from "vue";
  import { useRoute, useRouter } from 'vue-router'
  import { useI18n } from "vue-i18n";
  import { useStore } from "vuex"
  import { buyDLCOrder } from "@/api/index.js"
  import PaypalStep1 from "@/components/paypal_step1.vue"
  import PaypalStep2 from "@/components/paypal_step2.vue"
  import PaypalStep3 from "@/components/paypal_step3.vue"
  export default defineComponent({
    name: 'paypalInfo',
    components: {
      PaypalStep1,
      PaypalStep2,
      PaypalStep3
    },
    setup() {
      const { t, locale } = useI18n();
      const store = useStore()
      const message = inject('$message') 
      let lan = computed(() => {
        return store.state.lan
      })
      const router = useRouter()
      const route = useRoute()
      const active = ref(0)
      const buy_data = ref({
        usdt: 0,
        number: 0,
        wallet: '',
        buy_price: 0,
        transaction_fees: 0
      })
      const paypal_order_id = ref(null)
      const pay_usdt = ref(0)
      const next = () => {
        if (active.value++ > 2) active.value = 0
      }
      const setBuyData = (data) => {
        if (data.number&&data.usdt > 0) {
          buy_data.value = data
          pay_usdt.value = Math.ceil((buy_data.value.transaction_fees + buy_data.value.usdt) * 100) / 100
          active.value = 1
        }
      }
      const handleApprove = async (details) => {
        console.log('Payment approved:', details);
        paypal_order_id.value = details.id
        const data = {
          _id: details.id,
          wallet: buy_data.value.wallet,
          buy_number: buy_data.value.number,
          buy_usdt: buy_data.value.usdt,
          buy_price: buy_data.value.buy_price,
          buy_transaction_fees: buy_data.value.transaction_fees,
          buy_status: details.status,
          buy_purchase_status: details.purchase_units[0].payments.captures[0].status,
          buy_purchase: details.purchase_units[0],
          payment_approved: details
        }
        const save_data = await buyDLCOrder(data)
        console.log(save_data);
        if (save_data.success) {
          message({
            message: '支付完成，等待校验中',
            grouping: true,
            type: 'success'
          })
          active.value = 2
        } else {
          message({
            message: save_data.msg,
            grouping: true,
            type: 'error'
          })
        }
      }
      const handleError = async (err) => {
        console.error('Payment error:', err);
        message({
          message: err.message,
          grouping: true,
          type: 'error'
        })
      }
      const setStep = () => {
        active.value = 3
      }
      onMounted(async() => {
        
      })
      return {
        lan,
        next,
        active,
        setStep,
        buy_data,
        setBuyData,
        handleApprove,
        handleError,
        pay_usdt,
        paypal_order_id
      };
    }
  })
</script>

<style lang="scss" scoped>
.paypalInfo {
  margin: auto;
  width: 100%;
  overflow: hidden;
  font-style: normal;
  position: relative;
  .page_title {
    color: #fff;
    font-size: 48px;
    line-height: 1.1;
    font-weight: 600;
    font-family: Monda;
    text-align: center;
  }
  .page_title1 {
    font-size: 24px;
    line-height: 1.1;
    font-weight: 600;
    font-family: Outfit;
    color: rgba(255, 255, 255, .8);
  }
  .page_text {
    font-size: 16px;
    line-height: 1.1;
    font-family: Outfit;
    text-align: unset !important;
    color: rgba(255, 255, 255, .5);
    p {
      text-align: unset !important;
    }
  }
  .page_cont {
    position: relative;
    z-index: 2;
    width: 90%;
    // min-width: 600px;
    overflow: hidden;
    max-width: 1100px;
    margin: 100px auto;
    position: relative;
    .page_title {
      margin-bottom: 80px;
    }
    .page_img {
      width: 100%;
      margin: 30px 0;
      overflow: hidden;
      img {
        width: 100%;
        margin: auto;
        border-radius: 50px;
      }
    }
    .page_text {
      width: 100%;
    }
  }
}

</style>

